import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import FactsContext from '@Components/Results/substances/contexts/facts.context';
import NumberFormatter from '@Utils/NumberFormatter';
import { getFactCount } from '@Components/Results/substances/utils/factCountHelper';

function SubstanceFactLinks({ substance, onToggle }) {
  const { facts } = useContext(FactsContext);

  if (isEmpty(facts)) {
    return null;
  }

  return (
    <ul className={`substance-details-left ${facts && Object.keys(facts).length > 3 ? 'substance-details-left--columns' : ''}`}>
      {map(facts, (fact) => (
        <li key={fact.title}>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,react/jsx-no-script-url,no-script-url */}
          <a
            href="null"
            tabIndex="0"
            className={fact.className}
            onClick={(e) => {
              e.preventDefault();
              onToggle(fact.id);
            }}>
            {fact.title} {fact.count ? <span>- {NumberFormatter(getFactCount(fact, substance), 0)}</span> : null}
          </a>
        </li>
      ))}
    </ul>
  );
}

SubstanceFactLinks.propTypes = {
  substance: PropTypes.object.isRequired,
  onToggle: PropTypes.func.isRequired,
};

export default SubstanceFactLinks;
